import React from 'react';

import publicCloudsIcon from '@images/spe-cloud/cloud-public.svg';

export const publicClouds = {
  mainSection: {
    icon: publicCloudsIcon,
    elements: [
      {
        type: 'list',
        description: (
          <>
            As cloud-native development is on the rise, companies need to rethink their cloud strategy. Public clouds
            such as AWS, Azure, GCP, and IBM Cloud will likely figure in an effective strategy, as they offer
            considerable advantages:
          </>
        ),
        items: [
          <>Avoid high costs of purchasing, managing and maintaining on-prem hardware and application infrastructure</>,
          <>Shorten time-to-market, as public cloud can be deployed much faster than on-prem infrastructure</>,
          <>Ensure security on a par with the most effectively managed private clouds</>,
          <>Ensure high availability and virtually infinite scalability</>,
        ],
      },
    ],
  },
  howWeHelpSection: {
    elements: [
      {
        type: 'list',
        description: 'Our public cloud services include:',
        items: [
          <>Designing solution architectures</>,
          <>Moving on-prem apps to the public cloud (lift & shift)</>,
          <>Full stack development on public cloud (including UI and UX)</>,
          <>Full automation (CI/CD, QA)</>,
          <>Support and maintenance</>,
          <>Ensuring security and proper monitoring</>,
          <>Optimizing public cloud costs during development and maintenance</>,
        ],
      },
    ],
    relatedResources: [
      {
        type: 'Blog posts',
        items: [
          {
            title: 'AWS cost optimization—keeping cloud-based software development costs under control',
            link: '/blog/aws-cost-optimization-keeping-cloud-based-software-development-costs-under-control/',
          },
          {
            title: 'How to optimize GCP costs in cloud-based software development',
            link: '/blog/how-to-optimize-gcp-costs-in-cloud-based-software-development/',
          },
          {
            title: 'Microsoft Azure cost management in cloud-based software development',
            link: '/blog/microsoft-azure-cost-management-in-cloud-based-software-development/',
          },
        ],
      },
    ],
  },
};
